package xim.poc.game.configuration.v0.tactics.behaviors

import xim.poc.game.ActorState
import xim.poc.game.CombatBonusAggregate
import xim.poc.game.configuration.SkillApplierHelper
import xim.poc.game.configuration.constants.SkillId
import xim.poc.game.configuration.constants.mskillDiscordantNote_3507
import xim.poc.game.configuration.constants.mskillHypnosis_294
import xim.poc.game.configuration.v0.tactics.TacticsInstincts
import xim.poc.game.configuration.v0.tactics.addInstinct
import xim.poc.game.configuration.v0.tactics.getUnit
import xim.poc.game.event.Event

class TacticsDarkDragonBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    override fun onBehaviorInitialized(): List<Event> {
        actorState.getUnit()
            .addInstinct(TacticsInstincts.attackBonus, 30)
            .addInstinct(TacticsInstincts.magicAttackBonus, 30)
        return emptyList()
    }

    override fun getSelectableSkills(): List<SkillId> {
        return if (wantsToUseDisco() && isDisplayCharging()) {
            listOf(mskillDiscordantNote_3507)
        } else {
            super.getSelectableSkills() - mskillDiscordantNote_3507
        }
    }

    override fun applyTacticsBehaviorBonuses(aggregate: CombatBonusAggregate) {
        aggregate.knockBackResistance += 100
    }

    override fun onSkillExecutedScoped(primaryTargetContext: SkillApplierHelper.TargetEvaluatorContext): List<Event> {
        if (wantsToUseDisco()) { displayCharging(primaryTargetContext.context) }
        if (primaryTargetContext.skill == mskillDiscordantNote_3507) { endCharging() }
        return emptyList()
    }

    private fun wantsToUseDisco(): Boolean {
        return !hasUsedSkill(mskillDiscordantNote_3507) && actorState.getHpp() <= 0.66f
    }

}

class TacticsSeekerBehavior(actorState: ActorState): TacticsBehaviorController(actorState) {

    override fun estimateSkillValue(query: TacticsSkillQuery): Float {
        return if (query.skill == mskillHypnosis_294 && query.result.allTargetIds.size > 1) {
            10_000f
        } else {
            super.estimateSkillValue(query)
        }
    }

}